class ConfigurationManager {
  static get userRoles() {
    return class {
      static get administrators() {
        return 'Administrators';
      }
    }
  }

  static get users() {

    return class {
      static get amministrazione() {
        return "amministrazione";
      }

      static get kristianWib() {
        return "kristian.scipione";
      }

      static get marco() {
        return "marco";
      }

      static get barbara() {
        return "barbara";
      }

      static get fede() {
        return "federico.pastore@gomme-auto.com";
      }

      static get giorgio() {
        return "giorgio.giulidori";
      }

      static get giuseppe() {
        return "giuseppe.giusti";
      }

      static get backoffice() {
        return "backoffice";
      }

      static get viceversa() {
        return "viceversa";
      }

      static get michelinstats() {
        return "michelinstats";
      }
    }

  }
}

export default ConfigurationManager;